import { createContext } from 'react';

export const UserContext = createContext({});
export const withUserData = (Component) =>
  function WrapperComponent(props) {
    return (
      <UserContext.Consumer>
        {(contextProps) => <Component {...props} {...contextProps} />}
      </UserContext.Consumer>
    );
  };

